import { useCallback, useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import { getSessionId } from '../components/Chat/utils';

/**
 * Returns a stable getter that reads the current chat session_id at call time.
 *
 * session_id is persisted to sessionStorage by ChatBot whenever the WebSocket
 * server returns one. We read it at event-handler call time (rather than as
 * reactive state) because by the time any tracking event fires the session
 * will already have been written.
 */
export const useChatSessionId = (): (() => string | undefined) => {
  const { identifiers } = useContext(AppContext);
  const sessionKey = `${identifiers.projectId}:${identifiers.publicationId}`;
  return useCallback(() => getSessionId(sessionKey), [sessionKey]);
};
